import LocomotiveScroll from "locomotive-scroll";

export function initParallax(): void {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
}

function init() {
  const scroll = new LocomotiveScroll({
    el: document.querySelector("[data-scroll-container]"),
  });

  scroll.on("scroll", (args: any) => {
    const windowHeight = window.innerHeight;
    const items = Object.values(args.currentElements) as any[];
    for (const item of items) {
      const el = item.el as HTMLElement;
      const value = Number(el.dataset.scrollValue) / 100;
      const height = windowHeight;
      const parallaxHeight = height * value;
      const h = parallaxHeight * -0.5 + parallaxHeight * item.progress;
      transform(el, h);
    }
  });

  scroll.on("call", (className: string, flow: "enter" | "exit") => {
    if (flow === "enter") {
      document.documentElement.classList.add(className);
    } else {
      document.documentElement.classList.remove(className);
    }
  });
}

function transform(element: HTMLElement, y: number) {
  const transform = `matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0,0,${y},0,1)`;

  (element.style as any).webkitTransform = transform;
  (element.style as any).msTransform = transform;
  (element.style as any).transform = transform;
}
